import { useState } from "react";
import { getAuthUser, getFileUrl } from "../../utils/GetAuthUser";
import replyIcon from "../../assets/reply_icon.svg";

import { IoMdSend } from "react-icons/io";


// Recursive single comment component
const Comment = ({ comment, onAddReply, isSaving }) => {
  const [replying, setReplying] = useState(false);
  const [replyText, setReplyText] = useState("");

  const fileUrl = getFileUrl();
  const authUser = getAuthUser(); // ✅ fixed name conflict

  const handleReply = () => {
    if (replyText.trim()) {
      onAddReply(comment.id, replyText);
      setReplyText("");
      setReplying(false);
    }
  };

  // Sender image for existing comments
  const senderImage =
    comment.senderImage && comment.senderImage !== "null"
      ? `${fileUrl}${comment.senderImage}`
      : "/default-user.png";

  // ✅ current logged-in user's profile image (for reply box)
  const currentUserImage =
    authUser?.user?.image && authUser?.user?.image !== "null"
      ? `${fileUrl}${authUser.user.image}`
      : "/default-user.png";

  return (
    <div className=" ">
      <div className="flex gap-2 items-center flex-shrink sm:ml-10">
        <div className="w-10 h-9 sm:w-[54px] sm:h-12 rounded-full overflow-hidden flex items-center justify-center">
          <img
            src={senderImage}
            alt={comment.senderName}
            className="w-full h-full object-cover object-center aspect-square"
          />
        </div>

        <div className="w-full mt-5 sm:ml-8">
          <div className="w-full flex items-center justify-between">
            <p className="font-bold font-grotesk text-[16px] text-[#0B0F19]">{comment.senderName}</p>
            <p className="text-sm text-[#9397AD] font-medium font-grotesk">{comment.date}</p>
          </div>
          <p className="mt-1 text-sm text-[#696565] font-grotesk font-medium">{comment.comment}</p>
          {/* Reply button */}
          <button
            className="text-secondary text-xs font-grotesk font-medium mt-2 flex items-center gap-1"
            onClick={() => setReplying(!replying)}
          >
           <span><img src={replyIcon} alt="Reply" /></span> <span>Reply</span>
          </button>

          <hr className="h-2 w-full mt-3"/>
        </div>
      </div>

      {/* Reply form */}
      {replying && (
        <div className="sm:ml-6 mt-2">
          <div className="flex items-start sm:items-center gap-2">
            {/* ✅ Profile Pic */}
            <div className="w-10 h-10 sm:w-[69px] sm:h-[69px] border-2 border-primary rounded-full p-[1px] flex items-center justify-center shrink-0">
              <div className="w-10 h-9 sm:w-[57px] sm:h-[57px] rounded-full overflow-hidden">
                <img
                  src={currentUserImage}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="flex items-center rounded-[14px] overflow-hidden w-full sm:px-3 sm:py-3 p-2 bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color focus:ring-1 focus:ring-primary focus:border-primary">
              <input
                className="w-full outline-none"
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder="Write a reply..."
              />
              <button
                onClick={handleReply}
                disabled={isSaving}
                className={`sm:px-3 sm:py-1 rounded mt-1 text-white ${
                  isSaving
                    ? "bg-gray-400 cursor-not-allowed"
                    : "sm:bg-primary hover:bg-primary-dark"
                }`}
              >
                <span className="hidden sm:block">{isSaving ? "Saving..." : "Reply"}</span>
                <span className="block sm:hidden">{isSaving ? "..." : <IoMdSend className="bg-transparent text-primary text-xl" />}</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recursive replies */}
      {comment.replies?.length > 0 && (
        <div className=" mt-2">
          {comment.replies.map((reply) => (
            <Comment key={reply.id} comment={reply} onAddReply={onAddReply} />
          ))}
        </div>
      )}
    </div>
  );
};

// Main Comment Section
export const CommentSection = ({
  comments,
  onAddComment,
  onAddReply,
  isSaving,
}) => {
  const [commentText, setCommentText] = useState("");
  const fileUrl = getFileUrl();
  const authUser = getAuthUser();

  const handleAdd = () => {
    if (commentText.trim()) {
      onAddComment(commentText);
      setCommentText("");
    }
  };

  // ✅ current logged-in user's profile image (for new comment box)
  const currentUserImage =
    authUser?.user?.image && authUser?.user?.image !== "null"
      ? `${fileUrl}${authUser.user.image}`
      : "/default-user.png";

  return (
    <div>
      {/* Add Comment Box */}
      <div className="mb-4 w-full ">
        <div className="w-full mt-2 mb-4">
          <h1 className="font-bold font-grotesk text-primary text-[16px]">Comments</h1> 
          <hr className=" mt-2 h-4 w-full" />
        </div>
        <div className="flex items-center sm:items-center gap-2 sm:pl-5">
          {/* ✅ Profile Pic */}
          <div className="w-10 h-10 sm:w-[59px] sm:h-[59px] border-2 border-primary rounded-full overflow-hidden p-1 flex items-center justify-center shrink-0">
            
              <img
                src={currentUserImage}
                alt="Profile"
                className="w-full h-full object-cover rounded-full"
              />
            
          </div>

          <div className="flex items-center rounded-[14px] overflow-hidden w-full sm:px-3 sm:py-3 p-2 bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color focus:ring-1 focus:ring-primary focus:border-primary">
            <input
              className="w-full outline-none"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Write a comment..."
            />
            <button
              onClick={handleAdd}
              disabled={isSaving}
              className={`sm:px-3 sm:py-1 rounded mt-1 text-white ${
                isSaving
                  ? "bg-gray-400 cursor-not-allowed"
                  : "sm:bg-primary hover:bg-primary-dark"
              }`}
            >
              <span className="hidden sm:block">{isSaving ? "Saving..." : "Comment"}</span>
              <span className="block sm:hidden">{isSaving ? "..." : <IoMdSend className="bg-transparent text-primary text-xl" />}</span>
            </button>
          </div>
        </div>
      </div>

      {/* Render Comments */}
      <div>
        {comments?.length === 0 ? (
          <p className="text-gray-500 text-center py-4">
            No comments yet. Be the first to comment!
          </p>
        ) : (
          comments?.map((comment) => (
            <Comment
              key={comment.id}
              comment={comment}
              onAddReply={onAddReply}
              isSaving={isSaving}
            />
          ))
        )}
      </div>
    </div>
  );
};
